
// TBD: Decompose, use strategy for address apply, also add composition of validators.
var PaymentValidator = (function (PromiseUtil) {
	//tbd: it's not good this class accept order instead Delivery. It's will be better to check AgeRestricted here
	var PaymentValidator = function (order, terms, termsOurPay) {
		this._order = order;

		// optional
		this._terms = terms;

		// optional
		this._termsOurPay = termsOurPay;
	};

	_.extend(PaymentValidator.prototype, {

		isValid: function (opts) {
			return this.validate(opts).result;
		},

		_emailAddressFocus: function() {
			var $el = $('#CustomerEmail:visible');
			var el = $el && $el[0] || null;
			if (el) {
                el.focus({ preventScroll: false });
            }
        },

		// TBD: Open/closed principle violated.
		validate: function (opts) {

			// NOTE: adhoc super fast fix for validation for email on guest checkout. We need to place such logic to the views.
			if (app.settings.get('UseGuestCheckout') && !window.__isAuthorized__()) {
				var data = {};
				data.email = app.customerEmailModel.getValidatedEmail();
				data.name = window.__checkoutModel__.get('Delivery').get('Current').get('Name') || '';
				data.parameters = {};
                data.parameters.tcAccepted = app.customerEmailModel.getTC();
                data.parameters.emailsAccepted = app.customerEmailModel.getEmailAccept();

				if (!data.email && !app.customerEmailModel.getEmail()) {
					this._emailAddressFocus();
					alert("Please provide email address");
					return { result: false };
				} else if (app.customerEmailModel.getEmail() && !data.email) {
                    this._emailAddressFocus();
					alert("Please provide correct email address");
					return { result: false };
				}

				if (!(opts && opts.goToPayments)) {
					if (!data.parameters.tcAccepted) {
						alert("Please accept terms and conditions");
						return { result: false };
                    }
                    if (data.parameters.emailsAccepted === null) {
                        alert("Please choose an option for promotion emails");
                        return { result: false };
                    }
				}
			}

			var shippingAvailability = this._order.get('ShipmentsList').shippingAvailability();
            var mode = this._order.get('BasketMode') || 0;

			if (!shippingAvailability) {
				return { result: false, reason: CheckoutSettings.Validation.ShippingAvailability };
            }
			else if (this._terms && !this._terms.isValid()) {
                return { result: false, reason: CheckoutSettings.Validation.TermsAndConditions };
            } else if (this._termsOurPay && !this._termsOurPay.isValid()) {
                return { result: false, reason: CheckoutSettings.Validation.TermsAndConditionsOurPay };
            } else if (!this._order.get('DeliveryOptions').isValid()) {
                return { result: false, reason: CheckoutSettings.Validation.TermsAndConditionsOurPaySelect };
			} else if (mode === 0 && !this._order.get('Delivery').isValid()) {
                return { result: false, reason: CheckoutSettings.Validation.Delivery };
			} else if (mode === 1) {
				var delivery = this._order.get('Delivery');
				var giftIsValid = delivery.currentGiftAddress().isValid();
				var billingIsValid = delivery.currentBilling().isValid();

				if (!giftIsValid && !billingIsValid) {
					return { result: false, reason: CheckoutSettings.Validation.GiftBillingAddress };
				} else if (!giftIsValid) {
                    return { result: false, reason: CheckoutSettings.Validation.GiftAddress };
				} else if (!billingIsValid) {
                    return { result: false, reason: CheckoutSettings.Validation.BillingAddress };
                }
			} else if (!this._order.IsAgreeWithAgeRestricted()) {
                return { result: false, reason: CheckoutSettings.Validation.AgeRestricted };
            }

			return { result: true };
		},

		apply: function () {
			if (!this.isValid()) {
				return PromiseUtil.rejected();
			}
			return this._applyNewAddress();
		},

		_applyNewAddress: function () {
			var dc = this._order.get('Delivery').form();
			if (dc.isActive()) {
				return dc.save();
			} else {
				return PromiseUtil.resolved();
			}
		}
	});

	return PaymentValidator;
})(PromiseUtil);